export const HEADER_REGION_CHANGED = 'header:region_changed';
export const HEADER_SET_NB_CONSULTANT_PHONE = 'header:set_newbuilding_consultant_phone';
